const SET_ACTIVE_CUSTOM_FILTER = 'SET_ACTIVE_CUSTOM_FILTER';
const SET_CUSTOM_FILTERS = 'SET_CUSTOM_FILTERS';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_ACTIVE_CUSTOM_FILTER,
  SET_CUSTOM_FILTERS,
};
